import { FunctionComponent } from "react";

import styles from "./AnimatedDots.web.css";

export const AnimatedDots: FunctionComponent = () => (
  <span className={styles.loadingDotsContainer}>
    <span className={styles.dot} aria-hidden="true" />
    <span className={styles.dot} aria-hidden="true" />
    <span className={styles.dot} aria-hidden="true" />
  </span>
);
